module.exports = __webpack_public_path__ + "static/img/guard_type_xz1.78a4cbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guard/guard_type_xz1.png
// module id = MqJF
// module chunks = 0